import { createSlice } from '@reduxjs/toolkit'


const invoiceSlice = createSlice({
  name: 'invoiceSlice',
  initialState: {
    invoiceRegisterTabValue:0,
    invoiceMatchTabValue: 0,
    registerInvoiceData: [],
    selectedMatchData: [],
    filterData: {},
    invoiceMatchBoolData: false,
    invoiceCopyData: [],
    invoiceMatchData: [],
    invoiceNumber: false,
    invoiceExport: false,
    invoiceOutstandingData: {
      invoiceAmount: 0,
      advanceInvoicesAmount: 0,
      grnAmount: 0,
      outstanding: 0,
      checkMatchClicked: false,
    },
    invoiceBuData: null,
    invoiceMatchFilterData: false,
  },
  reducers: {
    updateInvoiceRegisterTabValue: (state, action) => {
      state.invoiceRegisterTabValue = action.payload
    },
    updateInvoiceMatchTabValue: (state, action) => {
      state.invoiceMatchTabValue = action.payload
    },
    updateRegisterInvoiceData: (state, action) => {
      state.registerInvoiceData = action.payload
    },
    updateSelectedMatchData: (state, action) => {
      state.selectedMatchData = action.payload
    },
    updateInvoiceFilterData: (state, action) => {
      state.filterData = action.payload
    },
    updateInvoiceMatchBoolData: (state, action) => {
      state.invoiceMatchBoolData = action.payload
    },
    updateInvoiceCopyData: (state, action) => {
      state.invoiceCopyData = action.payload
    },
    updateInvoiceMatchData: (state, action) => {
      state.invoiceMatchData = action.payload
    },
    updateInvoiceNumber: (state, action) => {
      state.invoiceNumber = action.payload
    },
    updateInvoiceExport: (state, action) => {
      state.invoiceExport = action.payload
    },
    updateInvoiceOutstandingData: (state, action) => {
      state.invoiceOutstandingData = action.payload
    },
    updateInvoiceBuData: (state, action) => {
      state.invoiceBuData = action.payload
    },
    updateInvoiceMatchFilterData: (state, action) => {
      state.invoiceMatchFilterData = action.payload
    },
  },
})

export const {
  updateInvoiceRegisterTabValue,
  updateRegisterInvoiceData,
  updateSelectedMatchData,
  updateInvoiceMatchTabValue,
  updateInvoiceFilterData,
  updateInvoiceMatchBoolData,
  updateInvoiceCopyData,
  updateInvoiceMatchData,
  updateInvoiceNumber,
  updateInvoiceExport,
  updateInvoiceOutstandingData,
  updateInvoiceBuData,
  updateInvoiceMatchFilterData
} = invoiceSlice.actions

export const invoiceDataReducer = invoiceSlice.reducer
